import common from './common.json';
import tasks from './tasks.json';

export default { common, tasks };
